import { render, staticRenderFns } from "./QuestionRadio.vue?vue&type=template&id=afcab91e&scoped=true"
import script from "./QuestionRadio.vue?vue&type=script&lang=js"
export * from "./QuestionRadio.vue?vue&type=script&lang=js"
import style0 from "./QuestionRadio.vue?vue&type=style&index=0&id=afcab91e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afcab91e",
  null
  
)

export default component.exports